"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = exports.invlerp = exports.clamp = exports.lerp = exports.FormatNumber = exports.IntRandomBetween = void 0;
/**
 * Generate random float between 2 floats.
 * @param min
 * @param max
 * @param getRandom Optionally pass a method that will be called to retrieve the random number
 * @returns
 */
var IntRandomBetween = function (min, max, getRandom) {
    return Math.round((getRandom ? getRandom() : Math.random()) * (max - min) + min);
};
exports.IntRandomBetween = IntRandomBetween;
var FormatNumber = function (num) {
    var digits = 2;
    var lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
};
exports.FormatNumber = FormatNumber;
// https://www.trysmudford.com/blog/linear-interpolation-functions/
var lerp = function (x, y, a) { return x * (1 - a) + y * a; };
exports.lerp = lerp;
var clamp = function (a, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 1; }
    return Math.min(max, Math.max(min, a));
};
exports.clamp = clamp;
var invlerp = function (x, y, a) { return (0, exports.clamp)((a - x) / (y - x)); };
exports.invlerp = invlerp;
var range = function (x1, y1, x2, y2, a) { return (0, exports.lerp)(x2, y2, (0, exports.invlerp)(x1, y1, a)); };
exports.range = range;
